import configApp from "./config-app";
import configCore from "./config-core";

let config = {
    endpoints: {
        backend: 'https://prod-backend.saladegestao.com/'
    },
    tests: {
        login: "admin@admin",
        password: "temp##988"
    },
    gmaps_key: 'AIzaSyDTNW3Z7vNAc7V-ze1_X_2VbucOFs0CbC4',
    tokens: {
        recaptcha_secret:  '6LcEX_QqAAAAAAJM94-ZZw0gn6mF8tj23O4AVSJD'
    },
    bucketS3: {
        accessKeyId: 'AKIA4AQ3UPPMHTOFDJGR',
        secretAccessKey: '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',
        region: 'us-east-1', 
        bucket: 'demonstracao-zellus.cc',
        path_default:'salagovernanca-demonstracao.cc'
    },
    ...configCore,
    ...configApp,
    routesNoAuth: [...configCore.routesNoAuth,...configApp.routesNoAuth]
}
export default config;
